import { render, staticRenderFns } from "./SecondFactorTablePane.vue?vue&type=template&id=fcb79f2c&scoped=true&"
import script from "./SecondFactorTablePane.vue?vue&type=script&lang=js&"
export * from "./SecondFactorTablePane.vue?vue&type=script&lang=js&"
import style0 from "./SecondFactorTablePane.vue?vue&type=style&index=0&id=fcb79f2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb79f2c",
  null
  
)

export default component.exports